import React from "react";

const NoDataFound: React.FC = ({
  title = "No Data Found",
}: {
  title?: string;
}) => {
  return (
    <div className="d-flex flex-column  gap-3 justify-content-center align-items-center">
      <img alt="" src={"../images/no_data.svg"} width={"160"} />
      <p className="fs-3 fw-bold gray-text">{title}</p>
    </div>
  );
};

export default NoDataFound;
